const retailStatusTypes = {
    ONBOARDED: 'CONNECTED',
    NOT_ONBOARDED: 'AWAITING_CONNECTION',
    DISCONNECTED: 'DISCONNECTED',
};

export default retailStatusTypes;
